export function xOAuthUrl(path = 'oauth/x/authorize') {
  const base = String(process.env.VUE_APP_X_OAUTH_URL || process.env.VUE_APP_LIVE_URL || '').replace(/\/$/, '');
  const frontend = encodeURIComponent(window.location.origin);
  const cleanPath = String(path).replace(/^\//, '');
  return `${base}/${cleanPath}?frontend=${frontend}`;
}

export function isFlagOn(value) {
  return value === true || value === 1 || value === '1';
}
